module.exports = __webpack_public_path__ + "static/media/subICloud2.0ef05e2c.png";